import { Alert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import * as React from 'react';

const Component: React.StatelessComponent<AlertProps> = props => <Alert {...props} />;

export default Component;
